import type { FC, ReactNode } from 'react'

import Image from 'next/image'
import { cn } from '@/lib/utils'

interface PictureProps {
    src: string
    alt: string
    sizes?: string
    priority?: boolean
    className?: string
    imgClassName?: string
    grade?: 'night' | 'dusk' | 'ink' | 'none'
}

const grades = {
    night: 'grade-night',
    dusk: 'grade-dusk',
    ink: 'grade-ink',
    none: ''
}

/**
 * A responsive image that fills its parent. Local images are optimised; images from storage
 * or another address are shown as they are, straight from the CDN.
 */
export const Picture: FC<PictureProps> = ({ src, alt, sizes = '100vw', priority = false, className, imgClassName, grade = 'none' }): ReactNode => {
    const remote = /^(https?:)?\/\//i.test(src) || src.startsWith('data:') || src.endsWith('.svg') || src.startsWith('/api/')

    return (
        <span className={cn('absolute inset-0 block overflow-hidden', className)}>
            <Image
                src={src}
                alt={alt}
                fill
                sizes={sizes}
                priority={priority}
                unoptimized={remote}
                className={cn('object-cover', grades[grade], imgClassName)}
            />
        </span>
    )
}
